import {
  ScreenSharePresets,
  VideoPresets,
  type RoomOptions,
  type ScreenShareCaptureOptions,
} from "livekit-client";

/**
 * Picture settings for the trainer room.
 * Keep in sync with LMS-FrontendStudentFlow/src/livekit/mediaPublish.ts.
 *
 * The stage used to look soft while fullscreen looked sharp: adaptive stream
 * measured CSS pixels, so a normal stage fit the half-resolution screen layer.
 * Fullscreen was large enough for the full layer. The floor is now 720p, and
 * the pixel density follows the screen so the stage asks for real pixels.
 * On a weak link the encoder keeps that resolution and drops frames.
 */
export const liveKitRoomOptions: RoomOptions = {
  adaptiveStream: { pixelDensity: "screen" },
  dynacast: true,
  videoCaptureDefaults: {
    resolution: VideoPresets.h720.resolution,
  },
  publishDefaults: {
    simulcast: true,
    degradationPreference: "maintain-resolution",
    videoEncoding: VideoPresets.h720.encoding,
    videoSimulcastLayers: [VideoPresets.h360],
    screenShareEncoding: ScreenSharePresets.h1080fps15.encoding,
    screenShareSimulcastLayers: [ScreenSharePresets.h720fps15],
  },
};

export const screenShareCaptureOptions: ScreenShareCaptureOptions = {
  contentHint: "detail",
  resolution: ScreenSharePresets.h1080fps15.resolution,
};
